/**
 * 시스템 > 동기화 현황 > 동기화 이력 Store
 *
 * @since 2018-10-10
 * @author devp018
 */

import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'
import {getCodeJsonRow} from '~/utils/device-common'
import {getChildrenFindVal} from '~/utils/admin-common'

export const state = () => ({
  BaseUrl: `${apiPrefix}/sync/hstry`,
  search: {
    id: '',
    page_num: 1,
    isFirst: true
  },
  searchData: {
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  // 필터 key 변경
  filterKey: {
    device_uname: 'device_id_list',
    menu_name: 'menu_id_list',
    // sync_start_dt: 'sync_start_dt',
    // sync_end_dt: 'sync_end_dt',
    sync_type_name: 'sync_type_list',
    sync_result_type_name: 'sync_result_type'
  },
  chgFieldData: null,
  // data
  dataList: [],
  menuData: [],
  syncType: [],
  syncHstryType: [],
  syncResultType: []
  // resultType: [
  //   {value: '1', name: '성공'},
  //   {value: '0', name: '실패'}
  // ]
})
export const mutations = {
  init (state) {
    state.searchData.filters = []
    state.chgFieldData = null
    state.dataList = []
    state.menuData = []
    state.syncType = []
    state.syncHstryType = []
    state.syncResultType = []
  },
  setSyncHstryData (state, data) {
    state.menuData = _.cloneDeep(data.menu)
    state.syncType = _.map(getCodeJsonRow('sync_type'), (item) => { // 동기화 유형
      return { value: item.key, label: item.val }
    })
    state.syncHstryType = _.map(getCodeJsonRow('sync_hstry_type'), (item) => { // 동기화 이력 유형
      return { value: item.key, label: item.val }
    })
    state.syncResultType = _.map(getCodeJsonRow('sync_result_type'), (item) => { // 결과
      return { value: item.key, label: item.val }
    })
  },
  mutGetSearchResult (state, payload) {
    const dataList = _.filter(payload, item => {
      // 메뉴 이름
      item.menu_name = getChildrenFindVal(state.menuData, {id: 'code', val: item.menu_id.toString()}, 'name')
      // 동기화 이력 유형
      const syncHstryType = state.syncHstryType.filter(_item => {
        return _item.value === item.sync_hstry_type
      })
      item.sync_hstry_type_name = ''
      if (syncHstryType.length > 0) {
        item.sync_hstry_type_name = syncHstryType[0].label
      }
      // 결과
      _.assign(item, { 'sync_result_type': (item.sync_hstry_type === 100) ? 1 : 0 })
      _.assign(item, { 'sync_result_type_name': '' })
      const syncResultType = state.syncResultType.filter(_item => {
        return _item.value === item.sync_result_type
      })
      if (syncResultType.length > 0) {
        item.sync_result_type_name = syncResultType[0].label
      }
      // 동기화 유형
      _.map(state.syncType, sync => {
        if (sync.value === item.sync_type) {
          item.sync_type_name = _.cloneDeep(sync.label)
        }
      })
      return item
    })

    state.dataList = Object.freeze(dataList)
  },
  mutGetSearchState (state, payload) {
    state.searchState.searched_cnt = _.cloneDeep(payload[0].cnt)
    state.search.page_num = 1
  }
}
export const actions = {
  async getSearchState ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const req = {}
      req['sync_start_dt'] = state.searchData.stime
      req['sync_end_dt'] = state.searchData.etime
      req['device_id_list'] = ''
      req['device_id_not_yn'] = 0
      req['menu_id_list'] = ''
      req['menu_id_not_yn'] = 0
      req['sync_result_type'] = ''
      req['sync_type_list'] = ''
      req['sync_type_not_yn'] = 0

      const
        filters = _.cloneDeep(state.searchData.filters),
        filterKey = _.cloneDeep(state.filterKey)

      filters.forEach(item => {
        const key = filterKey[item.key]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          if (key === 'sync_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[key] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
            req[`${key.replace(/(_list)$/, '')}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })

      res = await this.$axios.$post(state.BaseUrl, req, {loading: false, successAlert: false})

      if (res.code === 'ok') {
        commit('mutGetSearchState', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getSearchResult ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const req = {
        page_cnt: state.searchData.page_rows,
        page_pos: (state.search.page_num - 1)
      }
      req['sync_start_dt'] = state.searchData.stime
      req['sync_end_dt'] = state.searchData.etime
      req['device_id_list'] = ''
      req['device_id_not_yn'] = 0
      req['menu_id_list'] = ''
      req['menu_id_not_yn'] = 0
      req['sync_result_type'] = ''
      req['sync_type_list'] = ''
      req['sync_type_not_yn'] = 0

      const
        filters = _.cloneDeep(state.searchData.filters),
        filterKey = _.cloneDeep(state.filterKey)

      filters.forEach(item => {
        const key = filterKey[item.key]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          if (key === 'sync_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[key] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
            req[`${key.replace(/(_list)$/, '')}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })

      res = await this.$axios.$put(state.BaseUrl, req, {loading: true, successAlert: false})

      if (res.code === 'ok') {
        commit('mutGetSearchResult', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
